class GlossaryTermModel { 
    constructor(json) {
        if (!json) json = {};
        
        this.id = json.id;
        
        this.term = json.term;
        this.definition = json.definition;
        this.url = json.url;
        this.userId = json.user_id;
        
        this.created = json.created ? new Date(json.created) : null;
        this.modified = json.modified ? new Date(json.modified) : null;
    }
    
    toJson() {
        return {
            term: this.term,
            definition: this.definition,
            url: this.url
        };
    }
    
    static fromJsonArray(jsonArray) {
        if (!jsonArray) return [];
        return jsonArray.map(json => new GlossaryTermModel(json));
    }
}

export default GlossaryTermModel;
